module.exports = __webpack_public_path__ + "static/img/cePath1.ae39bb3d.gif";